import React,{Component} from 'react';
import connect from "react-redux/es/connect/connect";
import * as wActs from "../../actions/website-actions";
import {Link} from 'react-router-dom';
import Select from "react-select";
import PackItem from "./packitem";
class AdStepOne extends Component {

  constructor(props) {
    super(props);
    this.state = {
      homecc: "",
      country: "",
      packageId: "",
      packData: {},
      payby: "",
      size: "",
      usertype: ""
    };

    if(typeof window !== "undefined") {
      let data = localStorage.getItem("ad-data");
      if(!wActs.isNullOrUndefined(data)) {
        localStorage.removeItem("ad-data");
        let tObj = JSON.parse(data);
        this.setState({
          country: tObj.country,
          packageId: tObj.packageId,
          packData: tObj.packData,
          payby: tObj.payby,
          size: tObj.size,
          url: tObj.url,
          usertype: tObj.usertype,
          homecc: tObj.homecc,
        });
        return;
      }
    }



  }

  getTranslation(key)
  {
    let tStr = "";
    tStr =  this.props.WebPage.Translations[key];
    if(wActs.isNullOrUndefined(tStr)) { tStr = "" }
    return tStr;
  }

  isAgent() {
    try {
      if(wActs.isLoggedIn(this.props.WebPage)) {
        let type = this.props.WebPage.User.Type;
        if(type.toLowerCase().indexOf("agent")>-1) {
          return true;
        }
      }
    }catch(ex) {}
    return false;
  }
  isModel() {
    try {
      if(wActs.isLoggedIn(this.props.WebPage)) {
        let type = this.props.WebPage.User.Type;
        if(type.toLowerCase().indexOf("model")>-1) {
          return true;
        }
      }
    }catch(ex) {}
    return false;
  }
  isUser() {
    try {
      if(wActs.isLoggedIn(this.props.WebPage)) {
        let type = this.props.WebPage.User.Type;
        if(type.toLowerCase().indexOf("member")>-1) {
          return true;
        }
      }
    }catch(ex) {}
    return false;
  }

  getValues() {
    return  {
      homecc: wActs.isNullOrEmpty(this.HomeCountry.state.value) ? "" : this.HomeCountry.state.value.value,
      country: wActs.isNullOrEmpty(this.Country.state.value) ? "" : this.Country.state.value.value,
      payby: wActs.isNullOrEmpty(this.PayBy.state.value) ? "" : this.PayBy.state.value.value,
      size: wActs.isNullOrEmpty(this.Size.state.value) ? "" : this.Size.state.value.value,
      usertype: wActs.isNullOrEmpty(this.UserType.state.value) ? "" : this.UserType.state.value.value,
      startdate: this.StartDate.value
    };
  }

  handleSubmit(e) {
    e.preventDefault();
    let rec = this.getValues();
    this.props.handleSubmit(rec);
  }

  changeValue(type,sel) {
    if(wActs.isNullOrUndefined(sel)) { sel = {value: "", label: ""};}
    let rec = this.getValues();
    switch (type) {
      case "HOME" : {
        this.setState({homecc: sel.value});
        rec.homecc = sel.value;
        break;
      }
      case "COUNTRY" : {
        this.setState({country: sel.value});
        rec.country = sel.value;
        break;
      }
      case "PAYBY" : {
        this.setState({payby: sel.value});
        rec.payby = sel.value;
        break;
      }
      case "TYPE" : {
        this.setState({usertype: sel.value});
        rec.usertype = sel.value;
        break;
      }
      case "SIZE" : {
        this.setState({size: sel.value});
        rec.size = sel.value;
        break;
      }
      case "DATE" : {
        this.setState({startdate: sel});
        rec.startdate = sel;
        break;
      }
      default: {break;}
    }
    this.props.changeValue(type,rec);
  }





  render() {
    let ccDef = null;
    let ccNme = "";
    let defhcc = null;
    let defType = null;
    let sizeDef = null;
    let sizeNme = "";
    let sizes = [];
    let pays = [];
    let defPay = {};
    let utypes = [];
    let qCC = this.props.country;
    let qType = this.props.usertype;
    let qHCC = this.props.homecc;
    let url = typeof window === "undefined" ? this.props.WebPage.ServerParams.Referer + this.props.WebPage.ServerParams.Query : document.location.href;
    let Homedisabled = this.isModel() || this.isAgent();
    let Typedisabled = this.isAgent() || this.isModel();
    let loggedIn = wActs.isLoggedIn(this.props.WebPage);
    let sizeHeight = "auto";
    let sizeStyle = {display: "flex",alignItems: "center",justifyContent: "center",verticalAlign: "middle"};

    let packId = this.props.packageId;
    if(packId == 0) {
      packId = wActs.getParameterByName("packId",url,"0");
    }

    if(this.props.Ads.Loaded) {
      utypes = this.props.Ads.AdUserTypes.Result.map((v) => {
        return {label: v.DisplayValue, value: v.Id};
      });
      if(wActs.isNullOrEmpty(qCC)) { qCC = this.props.country; }
      if(wActs.isNullOrEmpty(qCC)) { qCC = this.props.Ads.AdUserInfo.Result.Current.Country.Code; }
      if(qCC=="ALL") {qCC =""}

      if(this.props.country !== null) {
        this.props.Ads.AdCountries.Result.map((v) => {
          if(v.Code === qCC) {
            ccDef = {label: v.Name, value: v.Code};
            ccNme = v.Name;
          }
        });
      }

      if(this.props.Ads.AdSizes.Loaded) {
        sizes = this.props.Ads.AdSizes.Result.map((v) => {return {value: v.Name, label: v.Name}});
        sizeNme = wActs.isNullOrEmpty(this.props.size) ? sizes[0].value : this.props.size;
        sizes.map((v) => {
          if(v.value == sizeNme) {sizeDef = v}
        });
        if(sizeNme !== "Profile" && sizeNme.indexOf("x")) {
          try {
            sizeHeight = sizeNme.split("x")[1];
            sizeHeight = parseInt(sizeHeight) + 60;
            sizeHeight = sizeHeight + "px";
          }catch(ex){}
        }
        sizeStyle.minHeight = sizeHeight;
      }


      if(loggedIn) {
        if(!wActs.isNullOrEmpty(this.props.Ads.AdUserInfo.Result)) {
          this.props.Ads.AllCountries.Result.map((v) => {
            if(v.Value === this.props.Ads.AdUserInfo.Result.Home.Country.Code) {
              defhcc = {label: v.DisplayValue, value: v.Value};
            }
          });
          utypes.map((v) => {
            if(v.value == this.props.Ads.AdUserInfo.Result.Type.Id) {
              defType = v;
            }
          });
        }
      } else {
        if(wActs.isNullOrEmpty(this.state.usertype)) { defType = wActs.getParameterByName("type",url,""); }
        if(wActs.isNullOrEmpty(defType) && !wActs.isNullOrEmpty(this.state.usertype)) { defType = this.state.usertype }
        utypes.map((v) => {
          if(v.value == defType) {
            defType = v;
          }
        });
        if(wActs.isNullOrEmpty(this.props.homecc)) { defhcc = wActs.getParameterByName("homecountry",url,""); }
        if(wActs.isNullOrEmpty(defhcc) && !wActs.isNullOrEmpty(this.props.homecc)) { defhcc = this.props.homecc; }
        if(wActs.isNullOrEmpty(defhcc)) {defhcc = this.props.Ads.AdUserInfo.Result.Home.Country.Code;}
        this.props.Ads.AllCountries.Result.map((v) => {
          if(v.Value === defhcc) {
            defhcc = {label: v.DisplayValue, value: v.Value};
          }
        });
      }
    }


    let showToks = wActs.isNullOrUndefined(this.props.WebPage.Settings.PayAdsWithTokens) ? false : this.props.WebPage.Settings.PayAdsWithTokens;
    if(wActs.isLoggedIn(this.props.WebPage)) {

      pays = [
        {label: `€ Euros`, value: "EUR"},
      ];
      if(showToks) {
        pays.push({label: `${this.getTranslation("dash.tokens")}`, value: "TOK"});
      }
    } else {
      pays = [
        {label: "Euros", value: "EUR"},
      ];
    }
    defPay = pays[0];
    /*
    if(!wActs.isNullOrUndefined(this.props.payBy)) {
      pays.map((v)=> {
        if(v.value == this.props.payBy) {
          defPay = v;
        }
      });
    }
    */
    let isAdult = wActs.isAdult(this.props.WebPage);

    return (
      <React.Fragment>
        <div className="sep"></div>

        <div className="half left" style={{minHeight: "160px"}}>
          <label htmlFor="">{this.getTranslation("page.advertise.advertisementcountry")}</label>
          <Select ref={(ref) => {this.Country=ref}} onChange={(sel) => {this.changeValue("COUNTRY",sel)}} style={wActs.customStyles} options={this.props.Ads.AdCountries.Result.map((v) => {return {label: v.Name, value: v.Code}})} placeholder="Select country..." defaultValue={ccDef}/>
          <div className="note">
            <p>{this.getTranslation("page.advertise.advertisementcountry.note")}</p>
          </div>
        </div>

        <div className="half right" style={{minHeight: "160px"}}>
          <label htmlFor="">{this.getTranslation("page.advertise.homecountry")}</label>
          <Select isDisabled={Homedisabled} ref={(ref) => {this.HomeCountry=ref}} onChange={(sel) => {this.changeValue("HOME",sel)}} style={wActs.customStyles} options={this.props.Ads.AllCountries.Result.map((v) => {return {label: v.DisplayValue, value: v.Value}})} defaultValue={defhcc} placeholder="Select country..."/>
          <div className="note"><p>{this.getTranslation("page.advertise.homecountry.note")}</p></div>
        </div>


        <div className="half left" style={{minHeight: "125px"}}>
          <label htmlFor="">{this.getTranslation("page.advertise.iama")}</label>
          <Select ref={(ref) => {this.UserType = ref}} isDisabled={Typedisabled} onChange={(sel) => {this.changeValue("TYPE",sel)}} ref={(ref) => {this.UserType=ref}} style={wActs.customStyles} options={utypes} defaultValue={defType} placeholder="Select..."/>
        </div>

        <div className="half right" style={{minHeight: "125px"}}>
          {this.props.Ads.AdSizes.Loaded &&
            <React.Fragment>
              <label htmlFor="">{this.getTranslation("page.advertise.advertisementsize")}</label>
              <Select ref={(ref) => {this.Size = ref}} onChange={(sel) => {this.changeValue("SIZE",sel)}} style={wActs.customStyles} options={sizes} defaultValue={sizeDef}/>
            </React.Fragment>
          }
        </div>

        <div className="half left" style={{minHeight: "125px"}}>
          <label htmlFor="">{this.getTranslation("page.advertise.startdate")}</label>
          <input ref={(ref) => {this.StartDate = ref}} type="date" defaultValue={this.props.startDate} onChange={(e) => {this.changeValue("DATE",e.target.value)}} style={{border: "solid 1px #ccc"}}/>
        </div>
        <div className="half right" style={{minHeight: "125px"}}>
          <label htmlFor="">{this.getTranslation("page.advertise.payby")}</label>
          <Select ref={(ref) => {this.PayBy = ref}} style={wActs.customStyles} options={pays} defaultValue={defPay} onChange={(sel) => {this.changeValue("PAYBY",sel)}}/>
        </div>


        {isAdult &&
        <div className={`cell x12`}>
          <div className="ad-greybox" style={{textAlign: "left", lineHeight: "15px", fontSize: "15px"}} dangerouslySetInnerHTML={{__html: this.getTranslation("page.advertise.networkofsitesheader")}}></div>
        </div>
        }


        <div className="clear"></div>
        <div className="sep"></div>


        {!this.props.Ads.AdPackages.Loaded &&
          <p style={{width: "100%", display: "flex", alignContent: "center", justifyContent: "center"}}>
            <img src="/imgs/loader.gif" width={"100px"} height={"100px"} alt={"Loading"}/>
          </p>
        }

        {this.props.Ads.AdPackages.Loaded &&
          <div className="ad-packages">
            {this.props.packs.length == 0 &&
            <div className="ad-greybox">
              There are no packages for this setup, please change your size or country.
            </div>
            }

            {this.props.packs.map((p,i)=>{
              let soldOut = false;
              if(p.MaxAds>0 && p.SoldAds >= p.MaxAds) {
                soldOut = true;
              }

              return (
                <PackItem key={"pack-" + p.PackageId}
                  checked = {packId == p.PackageId}
                  Package = {p}
                  soldOut = {soldOut}
                  payBy  = {this.props.payBy}
                  packageClick = {(packId) => {
                    if(typeof this.props.packageClick === "function") {
                      this.props.packageClick(packId);
                    }
                  }}
                />
              );
            })}
          </div>
          }

        <div className="clear"></div>

        <div className="centered-content m-t-l">
        <input type="submit" name="" onClick={(evt) => {this.handleSubmit(evt)}} value={this.getTranslation("page.advertise.createad")} style={{width: "65%"}}/>
        </div>

      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    WebPage: state.Website,
    Ads: state.Ads,
    Billing: state.Billing,
    CreateOrder: state.Billing.CreateOrder,
    CheckOrder: state.Billing.CheckOrder
  };
}

export default connect(mapStateToProps)(AdStepOne);




